import WebService from "./WebService";

export interface ExpenseQuery {
  page?: number;
  limit?: number;
  fromDate?: string;
  toDate?: string;
  category?: string;
  paymentMethod?: string;
  paidFrom?: string;
  cashBankAccountId?: number | string;
  vendorPayee?: string;
  createdBy?: number | string;
  status?: string;
  search?: string;
  period?: string;
}

function queryString(params: ExpenseQuery): string {
  const parts: string[] = [
    `page_number=${params.page ?? 1}`,
    `limit=${params.limit ?? 15}`,
  ];
  if (params.fromDate) parts.push(`from_date=${params.fromDate}`);
  if (params.toDate) parts.push(`to_date=${params.toDate}`);
  if (params.category) parts.push(`category=${encodeURIComponent(params.category)}`);
  if (params.paymentMethod) parts.push(`payment_method=${encodeURIComponent(params.paymentMethod)}`);
  if (params.paidFrom) parts.push(`paid_from=${encodeURIComponent(params.paidFrom)}`);
  if (params.cashBankAccountId) parts.push(`cash_bank_account_id=${params.cashBankAccountId}`);
  if (params.vendorPayee) parts.push(`vendor_payee=${encodeURIComponent(params.vendorPayee)}`);
  if (params.createdBy) parts.push(`created_by=${params.createdBy}`);
  if (params.status) parts.push(`status=${encodeURIComponent(params.status)}`);
  if (params.search) parts.push(`search=${encodeURIComponent(params.search)}`);
  if (params.period) parts.push(`period=${encodeURIComponent(params.period)}`);
  return parts.join("&");
}

export function fetchExpenseMeta() {
  return WebService.getAPI({
    action: "/v1/door-management/expenses/meta",
  });
}

export function fetchExpenses(params: ExpenseQuery = {}) {
  return WebService.getAPI({
    action: `/v1/door-management/expenses?${queryString(params)}`,
  });
}

export function fetchExpense(id: number | string) {
  return WebService.getAPI({
    action: `/v1/door-management/expenses/${id}`,
  });
}

export function createExpense(body: Record<string, unknown> | FormData) {
  return WebService.postAPI({
    action: "/v1/door-management/expenses",
    body,
  });
}

export function updateExpense(id: number | string, body: Record<string, unknown>) {
  return WebService.putAPI({
    action: `/v1/door-management/expenses/${id}`,
    body,
  });
}

export function cancelExpense(id: number | string, notes?: string) {
  return WebService.postAPI({
    action: `/v1/door-management/expenses/${id}/cancel`,
    body: notes ? { notes } : {},
  });
}

export function uploadExpenseDocument(id: number | string, file: File) {
  const formData = new FormData();
  formData.append("file", file);
  return WebService.postAPI({
    action: `/v1/door-management/expenses/${id}/documents`,
    body: formData,
  });
}
